import { observable } from "mobx";
import moment from "moment";
import uuid from "uuid";
import Model from "./Model";

class OpenHouse extends Model {
  /**
   * @property {number|null}
   */
  @observable start = null;

  /**
   * @property {number|null}
   */
  @observable end = null;

  #key = uuid.v4();

  get key() {
    return this.#key;
  }

  setData(data) {
    if (data.start) {
      this.start = moment(data.start).unix();
    }
    if (data.end) {
      this.end = moment(data.end).unix();
    }
  }
}

export default OpenHouse;
